var exports = {};
// generated by genversion
exports = "4.1.3";
export default exports;